import * as React from 'react';

import type { IconProps } from '../types';

const StatusIncircle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2607 1.60889C13.4372 1.60889 14.391 2.56266 14.391 3.7392V12.2605C14.391 13.437 13.4372 14.3908 12.2607 14.3908H3.73939C2.56285 14.3908 1.60907 13.437 1.60907 12.2605V3.7392C1.60907 2.56266 2.56285 1.60889 3.73939 1.60889H12.2607ZM8.00002 3.7392C5.64694 3.7392 3.73939 5.64676 3.73939 7.99984C3.73939 10.3529 5.64694 12.2605 8.00002 12.2605C10.3531 12.2605 12.2607 10.3529 12.2607 7.99984C12.2607 5.64676 10.3531 3.7392 8.00002 3.7392Z"
        />
      </svg>
    );
  }
);

StatusIncircle.displayName = 'StatusIncircle';

export { StatusIncircle };
